var map = {
	"./exocrine-pancreas-pathophysiology-banner.png": 87,
	"./handel-p-banner-old.png": 9785,
	"./handel-p-black-full.png": 9294,
	"./handel-p-black.png": 2622,
	"./handel-p-white-small.png": 4546,
	"./human-pancreas-analysis-program-hpap.png": 6530,
	"./integrated-islet-distribution-program-iidp-banner.png": 1360,
	"./neonatal-development--early-life-pancreas-handel-p.png": 8957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9164;